import { IconPrefixes } from './hmds.constants';

export enum Product {
  HESI = 'HESI',
  SPARK = 'SPARK',
}

export type ProductHeaderConfig = {
  title: string;
  titleClass?: string;
  backLinkText: string;
  tourButtonId: string;
  logo: {
    prefix: string;
    name: string;
    size: string;
  } | null;
};

export type ProductConfig = {
  header: ProductHeaderConfig;
  // When set, replaces the assignment title on the student home page.
  homePageTitle: string | null;
  // Student-facing name of the AI chat feature.
  aiChatName: string;
};

export const PRODUCT_CONFIG_MAP: Record<Product, ProductConfig> = {
  [Product.HESI]: {
    header: {
      title: 'Personalized Learning Plan',
      backLinkText: 'Back',
      tourButtonId: 'dashboard-tour-pendo-btn',
      logo: null,
    },
    homePageTitle: null,
    aiChatName: 'Sherpath AI',
  },
  [Product.SPARK]: {
    header: {
      title: 'MedEd Workspace',
      titleClass: 'u-els-color-elsevier-orange',
      backLinkText: 'Back to Test Prep',
      tourButtonId: 'spark-dashboard-tour-pendo-btn',
      logo: {
        prefix: IconPrefixes.HMDS,
        name: 'non-solus',
        size: '4x',
      },
    },
    homePageTitle: 'USMLE Readiness Plan',
    aiChatName: 'AI Coach',
  },
};
